import React from 'react';
import { IconProps } from '.';

const SvgClipboardFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 1a3.5 3.5 0 0 1 3.163 2H20a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4.837A3.5 3.5 0 0 1 12 1ZM7 17a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H7Zm0-4a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H7Zm0-4a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H7Zm5-5.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgClipboardFillRounded;
